import {
  GET_CALL_PROFILE_STICKY_COLUMNS,
  GET_CALL_PROFILE_STICKY_COLUMNS_SUCCESS,
  GET_CALL_PROFILE_STICKY_COLUMNS_ERROR,
  UPDATE_CALL_PROFILE_STICKY_COLUMNS,
  UPDATE_CALL_PROFILE_STICKY_COLUMNS_SUCCESS,
  UPDATE_CALL_PROFILE_STICKY_COLUMNS_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_call_profile: null,
  loading: false
}

const UserCallProfileColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_CALL_PROFILE_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_CALL_PROFILE_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_call_profile: action.payload,
        loading: false
      }

    case GET_CALL_PROFILE_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_CALL_PROFILE_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_CALL_PROFILE_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_call_profile: action.payload,
        loading: false
      }

    case UPDATE_CALL_PROFILE_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserCallProfileColumnPreference;
